"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var VerifiedAddress = function VerifiedAddress(_ref) {
  var address = _ref.address;
  var addressLines = address.addressLines,
      stateCode = address.stateCode,
      stateName = address.stateName,
      city = address.city,
      zipcode = address.zipcode;
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, addressLines && addressLines.map(function (line) {
    return /*#__PURE__*/_react.default.createElement(_material.Typography, {
      key: line,
      className: "Body-Regular-Left-Static"
    }, line);
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, city, ", ", stateCode || stateName, " ", zipcode), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "United States"));
};

var _default = /*#__PURE__*/(0, _react.memo)(VerifiedAddress);

exports.default = _default;